import {TopReelFeature} from "./TopReelFeature";
import {FeatureList, GameConfig, TopReelFeaturesList} from "../../../../GameConfig";
import {gsap} from "gsap";
import {HOTB} from "../../../../HOTB";
import {ReelView} from "../../../../reels/ReelView";
import {SymbolMultiplier} from "../../../../components/SymbolMultiplier";
import {AnimUtils} from "../../../../utils/AnimUtils";
import {GameSounds} from "../../../../sound/GameSounds";
import {ISymbol} from "../../../../../core/reel/IReelData";
import {GameSymbol} from "../../../../reels/GameSymbol";

export class XNudgeFeature extends TopReelFeature {
    private _nudgeMultiplier: SymbolMultiplier;

    constructor(reelId: number) {
        super(reelId, FeatureList.XNUDGE);
        this.createMultiplier();
        this.position.y = 80.5;
    }

    public startDrop(finalPosY: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        // do nothing

        return tl;
    }

    public finishDrop(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        // do nothing

        return tl;
    }

    public nudgeMultiplierBounce(): gsap.core.Timeline {
        const nudgeMultiplierTl: gsap.core.Timeline = gsap.timeline();
        nudgeMultiplierTl.to(this._nudgeMultiplier, {y: this._nudgeMultiplier.position.y - 25, duration: 0.15});
        nudgeMultiplierTl.to(this._nudgeMultiplier, {y: this._nudgeMultiplier.position.y, duration: 0.1});
        return nudgeMultiplierTl;
    }

    public performNudge(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline(),
            totalNudgeSteps: number = GameConfig.totalSymsPerReel - this.dropPosId,
            currReelView: ReelView = HOTB.reelArea.mainReelModels[this.reelId].reelView,
            nudgeStepAnim: string = "7_triggerStart";

        for (let i: number = 0; i < totalNudgeSteps; i++) {
            tl.add([
                this.playAnimation(nudgeStepAnim),
                this.nudgeMultiplierBounce(),
                gsap.to(this.position, {
                    y: (79 + (((this.dropPosId + i) + 1) * GameConfig.symbolHeight)) + ((i === (totalNudgeSteps - 1)) ? 12 : 0),
                    duration: GameConfig.nudgeStepDuration,
                    ease: "expo.in",
                    onComplete: (): void => {
                        if (i > 0) {
                            const currNudgedSymbol: ISymbol = HOTB.reelArea.getSymbolAtPosition(this.reelId, i + this.dropPosId);
                            let value: number = (<GameSymbol>currNudgedSymbol).splitCount;
                            value = value ? value : 1;
                            this._nudgeMultiplier.updateValue(value, true);

                            currReelView.removeNudgedSymbol();
                        } else {
                            this._nudgeMultiplier.updateValue();
                        }

                        this._nudgeMultiplier.alpha = 1;
                        AnimUtils.playScreenShake(GameConfig.itemDropShakePower);
                    }
                }),
                (): void => {
                    this.playSound(i);
                }
            ]);
        }

        return tl;
    }

    public expandNudge(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline(),
            nudgeExpandAnim: string = "8_triggerEnd",
            currReelView: ReelView = HOTB.reelArea.mainReelModels[this.reelId].reelView;

        tl.add([
            this.playAnimation(nudgeExpandAnim),
            (): void => {
                HOTB.soundPlayer.playSound(GameSounds.XNUDGE_EXPAND);
            },
            gsap.to(this._nudgeMultiplier.position, {
                y: -180,
                duration: GameConfig.nudgeStepDuration,
                ease: "expo.in"
            }),
            gsap.to(this._nudgeMultiplier.skew, {
                y: -0.05,
                duration: GameConfig.nudgeStepDuration,
                ease: "expo.in"
            })
        ],0);

        for (let symId: number = 0; symId < GameConfig.totalSymsPerReel; symId++) {
            tl.add((): void => {
                currReelView.createNudgeWild(this.reelId, symId, (symId === (GameConfig.totalSymsPerReel - 1)));
            }, 0.5);

            tl.add((): void =>{
                if(symId === 3) {
                    HOTB.reelArea.mainReelModels[this.reelId].reelView.checkForPossibleWinFromFeatures(this.reelId, symId, TopReelFeaturesList.XNUDGE);
                }
            });
        }

        return tl;
    }

    private playSound(step: number): void {
        let soundName: string;

        switch (step) {
            case 0:
                soundName = GameSounds.XNUDGE_DROP;
                break;
            case 1:
                soundName = GameSounds.XNUDGE_STEP_1;
                break;
            case 2:
                soundName = GameSounds.XNUDGE_STEP_2;
                break;
            case 3:
                soundName = GameSounds.XNUDGE_STEP_3;
                break;
            default:
                soundName = "";
                break;
        }

        HOTB.soundPlayer.playSound(soundName);
    }

    private createMultiplier(): void {
        this._nudgeMultiplier = new SymbolMultiplier(0);
        this._nudgeMultiplier.skew.set(0, 0.05);
        this.addChild(this._nudgeMultiplier);
    }
}